import React from 'react';
import PropTypes from 'prop-types';
import QuestionFooter from 'containers/QuestionnairePage/GenericQuestion/QuestionFooter';
import { QUESTION_ICON_MAP } from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/constants';
import { getTicksFromQuestion } from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/utils';
import QuestionPrompt from '../QuestionPromptViewOnly';

const SliderTickViewOnly = ({ tick }) => (
  <div className="flex  margin-btm-sm position-relative padding-left-lg">
    <span className="color-grey-7 margin-right-md">{tick.tickValue}</span>
    <span className="color-grey-10">{tick.tickLabel}</span>
  </div>
);

SliderTickViewOnly.propTypes = {
  tick: PropTypes.object.isRequired,
};

const SliderQuestionViewOnly = ({ question, renderPrompt }) => {
  const ticks = getTicksFromQuestion(question);
  return (
    <div>
      <QuestionPrompt
        className="margin-btm-sm"
        icon={QUESTION_ICON_MAP[question.type]}
        renderPrompt={renderPrompt}
        questionIndex={question.questionIndex}
        label={question.label}
      />
      {ticks.map((tick, index) => (
        <SliderTickViewOnly key={tick.refId} tick={tick} index={index + 1} />
      ))}
      <QuestionFooter
        key={`${question.refId}-${question.type}-footer`}
        type={question.type}
        label={question.label}
        goesTo={question.goesTo}
        goesToWithErrors={question.goesToWithErrors}
        comesFrom={question.comesFrom}
        isUnused={question.isUnused}
        invalidReferences={question.invalidReferences}
        invalidReferencesAnswersLogic={question.invalidReferencesAnswersLogic}
        invalidReferencesVariablesLogic={
          question.invalidReferencesVariablesLogic
        }
        media={question.media}
        shuffle={question.shuffle}
        ratingSize={question.ratingSize}
        selectedAttributes={question.selectedAttributes}
        answers={question.answers}
        attributes={[]}
        hiddenVariables={question.hiddenVariables}
        readOnly
      />
    </div>
  );
};

SliderQuestionViewOnly.propTypes = {
  question: PropTypes.object.isRequired,
  renderPrompt: PropTypes.func.isRequired,
};

export default SliderQuestionViewOnly;
